import { render, staticRenderFns } from "./OpcaoBusca.vue?vue&type=template&id=492704c8&scoped=true"
import script from "./OpcaoBusca.vue?vue&type=script&lang=js"
export * from "./OpcaoBusca.vue?vue&type=script&lang=js"
import style0 from "./OpcaoBusca.vue?vue&type=style&index=0&id=492704c8&prod&lang=scss"
import style1 from "./OpcaoBusca.vue?vue&type=style&index=1&id=492704c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492704c8",
  null
  
)

export default component.exports